import { Pagination } from "@mui/material";
import React, { useState } from "react";
import { dispatchStore } from "../lib/dispatchStore";
import { saleReportSlice } from "../helper/customSlice";
import moment from "moment";

const ReportTable = ({
  data,
  columns,
  childColumns,
  onPageChange,
  currentPage,
  ordersPerPage,
  TotalPage,
  Listpage,
  reachEnd,
}) => {
  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRow = (rowIndex) => {
    setExpandedRows((prev) =>
      prev.includes(rowIndex)
        ? prev.filter((index) => index !== rowIndex)
        : [...prev, rowIndex]
    );
  };

  const handleChange = (event, value) => {
    if (Listpage != undefined && reachEnd == false) {
      dispatchStore(saleReportSlice.actions.plusListpage(value));
    }
  };

  // const indexOfFirstRow = (Listpage - 1) * ordersPerPage;
  // const indexOfLastRow = Listpage * ordersPerPage;
  // const currentRows = data?.slice(indexOfFirstRow, indexOfLastRow) || [];

  return (
    <>
      <table className="table-auto border-collapse border border-gray-300 shadow-md text-[14px] mb-8">
        <thead>
          <tr className="bg-[#164571] text-white-1">
            <th className="border border-gray-400 px-4 py-2 font-semibold text-white">
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                />
              </svg> */}
            </th>
            <th className="border border-gray-400 px-4 py-2 font-semibold text-white">
              No
            </th>
            {columns.map((column, index) => (
              <th
                key={index}
                className="border border-gray-400 px-4 py-2 font-semibold text-white"
              >
                {column.headerName}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((order, index) => (
            <React.Fragment key={index}>
              {/* Parent Row */}
              <tr className="hover:bg-gray-100 text-center">
                <td className="border border-gray-400 px-4 py-2 text-center">
                  <button
                    onClick={() => toggleRow(index)}
                    className="text-sm font-bold text-gray-700"
                  >
                    {expandedRows.includes(index) ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m19.5 8.25-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m8.25 4.5 7.5 7.5-7.5 7.5"
                        />
                      </svg>
                    )}
                  </button>
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {(Listpage - 1) * ordersPerPage + index + 1}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.sale_order}
                </td>
                <td className="border border-gray-400 px-4 py-2 text-end">
                  {order?.total?.toLocaleString()}
                </td>
                <td className="border border-gray-400 px-4 py-2 text-end">
                  {order?.gross?.toLocaleString()}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.customer}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {/* {order?.date_order ? `${order?.date_order}` : "-"} */}
                  {moment(order?.date_order).format("DD/MM/YYYY")}{" "}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.order_status?.toLocaleString()}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.invoice_status}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.checked ? "Yes" : "No"}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.live_sale_session
                    ? `${order?.live_sale_session}`
                    : "-"}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.live_sale_room ? `${order?.live_sale_room}` : "-"}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {order?.sale_person ? `${order?.sale_person}` : "-"}
                </td>
              </tr>

              {/* {console.log(expandedRows, "err")} */}

              {/* Child Table */}
              {/* {expandedRows.includes(index) &&
                order?.order_lines?.length > 0 && (
                  <tr
                    className={`transition-all duration-300 ease-in-out ${
                      expandedRows.includes(index)
                        ? "max-h-96 opacity-100 visible"
                        : "max-h-0 opacity-0 invisible"
                    } overflow-hidden`}
                  >
                    <td></td>
                    <td colSpan={columns.length + 1} className="pt-2 pr-4">
                      <div className="bg-gray-50 ">
                        <table className="table-auto border-collapse border border-gray-500 w-full text-[13px] mb-6">
                          <thead>
                            <tr className="bg-gray-400">
                              <th className="border border-gray-300 px-4 py-2">
                                No
                              </th>
                              {childColumns.map((child, childIndex) => (
                                <th
                                  key={childIndex}
                                  className="border border-gray-300 px-4 py-2"
                                >
                                  {child.headerName}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {order?.order_lines?.map(
                              (product, productIndex) => (
                                <tr key={productIndex}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {productIndex + 1}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.product}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.category}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.cost?.toLocaleString()}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.livesale_price?.toLocaleString()}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.gross?.toLocaleString()}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.livesale_code
                                      ? `${product?.livesale_code}`
                                      : "-"}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2">
                                    {product?.foc ? "Yes" : "No"}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )} */}
              {expandedRows.includes(index) && (
                <tr
                  className={`transition-all duration-300 ease-in-out border border-gray-400 ${
                    expandedRows.includes(index)
                      ? "max-h-96 opacity-100 visible"
                      : "max-h-0 opacity-0 invisible"
                  } overflow-hidden`}
                >
                  <td></td>
                  <td colSpan={columns.length + 1} className="pt-2 pr-4">
                    <div>
                      <h4 className="text-center font-bold mt-2 mb-4">
                        Order Lines Data
                      </h4>
                      <table className="table-auto border-collapse border border-gray-500 w-full text-[13px] mb-6">
                        <thead>
                          <tr className="bg-gray-400">
                            <th className="border border-gray-300 px-4 py-2">
                              No
                            </th>
                            {childColumns.map((child, childIndex) => (
                              <th
                                key={childIndex}
                                className="border border-gray-300 px-4 py-2"
                              >
                                {child.headerName}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {order?.order_lines?.length > 0 ? (
                            order.order_lines.map((product, productIndex) => (
                              <tr key={productIndex} className="text-center">
                                <td className="border border-gray-300 px-4 py-2">
                                  {productIndex + 1}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  {product?.product}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  {product?.livesale_code
                                    ? product.livesale_code
                                    : "-"}
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  {product?.livesale_price?.toLocaleString()}
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  {product?.quantity}
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  {product?.cost?.toLocaleString()}
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  {product?.gross?.toLocaleString()}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  {product?.foc ? "Yes" : "No"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={childColumns.length + 1}
                                className="border border-gray-300 px-4 py-2 text-center text-gray-500"
                              >
                                No order line to display.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {data?.length > 0 && TotalPage > 1 && (
        <div className="flex justify-center mt-3 mb-6 bottom-0 w-full ">
          <Pagination
            count={TotalPage}
            page={Listpage}
            onChange={handleChange}
            color="primary"
          />
        </div>
      )}
    </>
  );
};

export default ReportTable;
